"use client";
import React, { useEffect, useRef, useState } from "react";
import Image from "next/image";

interface DropdownMenuProps {
  text: string;
  items: any[];
  onItemClick: (item: string) => void;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  text,
  items,
  onItemClick,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutSide = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutSide);

    return () => {
      document.removeEventListener('mousedown', handleClickOutSide);
    };
  }, []);

  // const handleMouseEnter = () => {
  //   setDropdownOpen(true);
  // };

  // const handleMouseLeave = () => {
  //   setDropdownOpen(false);
  // };

  const handleItemClick = (item: string) => {
    onItemClick(item);
    setDropdownOpen(false); // Close the dropdown after an item is clicked
  };

  return (
    <div ref={dropdownRef} className="relative">
      <div onClick={() => setDropdownOpen(!dropdownOpen)} className="h-[46px] px-2.5 py-1 rounded-lg border border-black justify-center items-center inline-flex cursor-pointer">
        <div className="text-center text-black text-[24px] font-barlowNormal leading-[38px] flex items-center">
          {text}
          <Image
            src="/product/listing/dropdown-icon.png"
            alt="Dropdown Icon"
            height={9}
            width={9}
            className="ml-2 h-[8px] w-auto"
          />
        </div>
      </div>
      {dropdownOpen && (
        <div className="pt-1">
          <div className="absolute bg-black rounded-lg w-full min-w-max">
            <ul className="py-2">
              {items.map((item, index) => {
                return(
                <li
                  key={index}
                  className="px-4 py-2 hover:bg-gray-200 hover:text-[#000] cursor-pointer whitespace-nowrap"
                  onClick={() => handleItemClick(item?.value)}
                >
                  {item?.title}
                </li>
              )})}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
